/* eslint-disable prettier/prettier */
import React, { useState, useEffect, useRef } from 'react';
import './css/style.scss';
import { useDispatch, useSelector } from 'react-redux';
import { postAnalyticsCTA, updateCtaSchedule } from '../../../Store/actions/commonActions';
import { toast } from 'react-toastify';
import ctaBnr from './images/callCenter-min.png';
import { EmailUpdateModal, PhoneUpdateModal } from '../../modals';
import { MdOutlineArrowRightAlt } from '../../icons';
import { useInView } from 'react-intersection-observer';
import { getLocalStorage, getCurrentTime, reactHtmlParser } from '../../../common/common';
// import ReactHtmlParser from 'react-html-parser';

import { fetchCTA, clearCTA } from '../../../Store/actions/commonActions';
import { PopupModal, useCalendlyEventListener } from 'react-calendly';
import packageJson from '../../../../package.json';
import Loader from 'react-loader-spinner';
import LazyImage from '../../CustomLibraries/LazyImage';

const REQUEST_TYPE_CALLBACK = 1;
const REQUEST_TYPE_SCHEDULE = 2;
let currentActionType = '';
function CtaCardSchedule({ data = {}, onVisibilityChange, content_type, content_id }) {
  const {
    title,
    description,
    button_text,
    id,
    logo,
    cta_url,
    callback_status,
    schedule_status,
    cta_type,
    cta_type_id,
    type,
    type_id,
    position
  } = data;

  const [email, setEmail] = useState(
    getLocalStorage('user', false) ? getLocalStorage('user', '{}')?.email : ''
  );

  const [phone, setPhone] = useState(
    getLocalStorage('user', false) ? getLocalStorage('user', '{}')?.mobile_primary : ''
  );
  const [phoneModalShow, setPhoneModalShow] = useState(false);
  const [emailModalShow, setEmailModalShow] = useState(false);

  const [isd, setIsd] = useState('+91');
  const [otp, setOtp] = useState('');
  const [isVisible, setIsVisible] = useState(false);

  const [popupUrl, setPopupUrl] = useState(cta_url ?? '');
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const [first_name, set_first_name] = useState(
    getLocalStorage('user', false) ? getLocalStorage('user', '{}')?.first_name : ''
  );

  const [middle_name, set_middle_name] = useState(
    getLocalStorage('user', false) ? getLocalStorage('user', '{}')?.middle_name : ''
  );

  const [last_name, set_last_name] = useState(
    getLocalStorage('user', false) ? getLocalStorage('user', '{}')?.last_name : ''
  );

  const [isLoading, setIsLoading] = useState(false);

  // const [actionType, setActionType] = useState('');

  const dispatch = useDispatch();

  const pageSettings = {
    backgroundColor: 'ffffff',
    hideEventTypeDetails: false,
    hideLandingPageDetails: false,
    primaryColor: '00a2ff',
    textColor: '4d5055'
  };

  const prefill = {
    email: email ?? '',
    firstName: first_name ?? '',
    lastName: last_name ?? ' ',
    name: `${first_name} ${middle_name} ${last_name}`,

    // guests: ['name@example.com'],
    customAnswers: {
      a1: phone ? `${isd}${phone}` : ''
    },
    date: new Date(Date.now() + 86400000)
  };

  let utm = {
    utmCampaign: '',
    utmContent: window.location.href,
    utmMedium: `CLIRNET v${packageJson.version}`,
    utmSource: getLocalStorage('utm_source', false)
      ? getLocalStorage('utm_source', 'not found')
      : '',
    utmTerm: ''
  };

  useCalendlyEventListener({
    onProfilePageViewed: (e) => console.log('onProfilePageViewed' + JSON.stringify(e.data)),
    onDateAndTimeSelected: (e) => console.log('onDateAndTimeSelected' + JSON.stringify(e.data)),
    onEventTypeViewed: (e) => console.log('onEventTypeViewed' + JSON.stringify(e.data)),
    onEventScheduled: (e) => updateScheduleCallBackData(JSON.stringify(e.data.payload))
  });

  const [ctaContainer, inView] = useInView({
    fallbackInView: false,
    threshold: 0.1
  });

  const onRequestCallbackClick = () => {
    currentActionType = REQUEST_TYPE_CALLBACK;
    validateEmailAndPhone(REQUEST_TYPE_CALLBACK);
  };

  const onScheduleClick = () => {
    currentActionType = REQUEST_TYPE_SCHEDULE;
    validateEmailAndPhone(REQUEST_TYPE_SCHEDULE);
  };

  const updateSchedule = (params_type) => {
    if (id && currentActionType == REQUEST_TYPE_CALLBACK && !isLoading) {
      setIsLoading(true);

      let currentTime = '';
      currentTime = getCurrentTime();
      console.log('updateSchedule');
      let temp_json_data = {
        cta_id: id,
        contact_type: params_type,
        schedule: 123,
        content_type: content_type ?? 0,
        content_id: content_id ?? 0,
        schedule_data: currentTime ?? ''
      };

      dispatch(
        updateCtaSchedule(temp_json_data, (response) => {
          setIsLoading(false);
          console.log('no callback xid' + JSON.stringify(response));
          currentActionType = '';
          if (response.status_code == 200) {
            let postObj = {
              cta_type,
              cta_type_id,
              target_type: type,
              target_type_id: type_id,
              position,
              cta_id: id
            };

            toast.success(response.message);
            dispatch(fetchCTA(content_type, content_id, (response) => { }));
            dispatch(postAnalyticsCTA(postObj, () => { }));
          }
        })
      );
    } else if (id && currentActionType == REQUEST_TYPE_SCHEDULE) {
      // setPopupUrl(cta_url);
      setIsPopupOpen(true);
    } else {
      toast.success('Something Wrong Happen');
    }
  };

  const updateScheduleCallBackData = (schedule_data = '') => {
    if (id) {
      setIsLoading(true);
      console.log('updateSchedule');
      let temp_json_data = {
        cta_id: id,
        contact_type: currentActionType,
        content_type: content_type ?? 0,
        content_id: content_id ?? 0,
        schedule_data: schedule_data ?? ''
      };

      dispatch(
        updateCtaSchedule(temp_json_data, (response) => {
          console.log('no id' + JSON.stringify(response));
          currentActionType = '';
          if (response?.status_code == 200 && response?.message) {
            dispatch(
              fetchCTA(content_type, content_id, (response) => {
                setIsLoading(false);
              })
            );
            toast.success(response.message);
            let postObj = {
              cta_type,
              cta_type_id,
              target_type: type,
              target_type_id: type_id,
              position,
              cta_id: id
            };

            dispatch(postAnalyticsCTA(postObj, () => { }));
          }
        })
      );
    } else {
      toast.success('Something Wrong Happen');
    }
  };

  let validateEmailAndPhone = (type) => {
    console.log('click detected' + type);
    if (!email || !phone) {
      console.log('something detected');
      if (!email) {
        setEmailModalShow(true);
        console.log('no email detected' + emailModalShow);
      } else if (!phone) {
        setPhoneModalShow(true);
        console.log('no phone detected' + phoneModalShow);
      } else {
        updateSchedule(type);
        console.log('nothing detected');
      }
    } else {
      updateSchedule(type);
      console.log('nothing detected1');
    }
  };

  let onFloatingBannerClick = () => {
    document
      .getElementById('schedule_cta_section')
      .scrollIntoView({ behavior: 'smooth', block: 'center' });
    // scrollToRef(ctaContainer);
  };
  const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop);

  useEffect(() => {
    setIsVisible(inView);
    if (inView) {
      onVisibilityChange();
    }
    console.log('in view' + inView);
  }, [inView]);

  let onEmailVerificationComplete = () => {
    // setEmail(getLocalStorage('user', false) ? getLocalStorage('user', '{}')?.email : '');
    setEmail(getLocalStorage('user', false) ? getLocalStorage('user', '{}')?.email : '');
    if (currentActionType && currentActionType == REQUEST_TYPE_CALLBACK) {
      console.log('onEmailVerificationComplete' + REQUEST_TYPE_CALLBACK);
      updateSchedule(REQUEST_TYPE_CALLBACK);
    } else if (currentActionType && currentActionType == REQUEST_TYPE_SCHEDULE) {
      console.log('onEmailVerificationComplete1' + REQUEST_TYPE_SCHEDULE);
      updateSchedule(REQUEST_TYPE_SCHEDULE);
    } else {
      console.log('onEmailVerificationComplete2');
      currentActionType = '';
    }
  };
  let onMobileVerificationComplete = () => {
    setPhone(getLocalStorage('user', false) ? getLocalStorage('user', '{}')?.mobile_primary : '');

    if (currentActionType && currentActionType == REQUEST_TYPE_CALLBACK) {
      console.log('onMobileVerificationComplete' + REQUEST_TYPE_CALLBACK);
      updateSchedule(REQUEST_TYPE_CALLBACK);
    } else if (currentActionType && currentActionType == REQUEST_TYPE_SCHEDULE) {
      console.log('onMobileVerificationComplete 1' + REQUEST_TYPE_SCHEDULE);
      updateSchedule(REQUEST_TYPE_SCHEDULE);
    } else {
      console.log('onMobileVerificationComplete 2');
      currentActionType = '';
    }
  };
  let onEmailHide = () => {
    console.log('onEmailHide 2');
    currentActionType = '';
    if (emailModalShow) {
      setEmailModalShow(false);
    } else {
    }
  };
  let onMobileHide = () => {
    console.log('onMobileHide 2');
    currentActionType = '';
    if (phoneModalShow) {
      setPhoneModalShow(false);
    }
  };
  let onCallBackScheduleClick = () => {
    toast.success(
      `Dear Dr. ${first_name} Your call back request has been noted, a Medical Scientific Liaison will be in touch shortly!`
    );
  };
  let onCancelPopupClick = () => {
    setIsPopupOpen(false);
    if (emailModalShow) {
      setEmailModalShow(false);
    } else if (phoneModalShow) {
      setPhoneModalShow(false);
    }
  };
  return (
    <>
      <div className="w-100 ctaCardV6Box row">
        <div
          className="col-lg-3 col-md-4 col-12 p-0"
          id="schedule_cta_section"
          ref={ctaContainer}
        >
          {logo ? (
            <LazyImage
              src={logo}
              className="object-fit-cover w-100 h-100 float-start ctaImg"
              alt="banner"
              logo
            />
          ) : (
            <img
              src={ctaBnr}
              className="object-fit-cover w-100 h-100 float-start ctaImg"
              alt="banner"
            />
          )}
        </div>
        <div className="col-lg-9 col-md-8 col-12 d-flex align-items-center flex-column justify-content-center px-sm-4 py-sm-3 p-3 flex-column">
          {title && (
            <h2 className="fs-2 text-black fw-semibold text-start mb-4 ctaCardTitle w-100">
              {reactHtmlParser(title)}
            </h2>
          )}
          {description && (
            <p className="fs-16 text-dark fw-normal text-start w-100">
              {description && reactHtmlParser(description)}
            </p>
          )}
          {/* {description && ReactHtmlParser(description)} */}

          <div className="d-flex align-items-center justify-content-start w-100 pt-3  gap-3">
            {callback_status == 1 || schedule_status == 1 ? (
              <a
                className="fs-16 btn btn-secondary fw-medium text-start ctaLinkB text-nowrap flex-shrink-0"
                onClick={onCallBackScheduleClick}
              >
                Callback Scheduled
              </a>
            ) : (
              <>
                {callback_status != 1 && (
                  <button
                    className="fs-16 btn btn-primary fw-medium text-start ctaLink text-nowrap flex-shrink-0"
                    onClick={onRequestCallbackClick}
                    disabled={isLoading}
                  >
                    {!isLoading ? (
                      'Call Me Now'
                    ) : (
                      <Loader type="ThreeDots" color="#FFFFFF" height={25} width={30} />
                    )}
                  </button>
                )}
                {schedule_status != 1 && (
                  <button
                    className="fs-16 btn btn-secondary fw-medium text-start ctaLinkB text-nowrap flex-shrink-0"
                    onClick={onScheduleClick}
                    disabled={isLoading}
                  >
                    {!isLoading ? (
                      'Schedule A Call'
                    ) : (
                      <Loader type="ThreeDots" color="#FFFFFF" height={25} width={30} />
                    )}
                  </button>
                )}
              </>
            )}
          </div>
        </div>

      </div>

      {!isVisible && (
        <div className=" ctaCardV6BoxMob d-flex align-items-center justify-content-center flex-wrap fixed-bottom overflow-hidden m-0 bg-white" style={{ zIndex: 9999 }}>
          {logo ? (
            <div className="img-area">
              <LazyImage
                src={logo}
                className="object-fit-cover w-100 h-100 float-start rounded-circle"
                alt="banner"
                logo
              />
            </div>
          ) : (
            <div className="img-area">
              <LazyImage
                src={ctaBnr}
                className="object-fit-cover w-100 h-100 float-start rounded-circle"
                alt="banner"
                logo
              />
            </div>
          )}
          <div className="middle-area">
            {title && (
              <p className="fs-4 text-black text-start ctaCardTitle w-100">
                {reactHtmlParser(title)}
              </p>
            )}
            {/* {description && <p className="fs-16 text-dark fw-normal text-start">{description}</p>} */}
          </div>
          <div className="icon-area" onClick={onFloatingBannerClick}>
            <div className="rounded-pill hospitlLandingBxArrow d-flex align-items-center justify-content-center cursorPointer">
              <MdOutlineArrowRightAlt customClass="fs-1 text-white" />
            </div>
          </div>
        </div>
      )}
      {emailModalShow && (
        <EmailUpdateModal
          title="Please Enter Your Email To Schedule An appointment"
          show={emailModalShow}
          onModalHide={onEmailHide}
          onVerificationDone={onEmailVerificationComplete}
        />
      )}
      {phoneModalShow && (
        <PhoneUpdateModal
          show={phoneModalShow}
          onModalHide={onMobileHide}
          onVerificationDone={onMobileVerificationComplete}
        />
      )}
      {/* {popupUrl && ( */}
      <PopupModal
        url={popupUrl ?? ''}
        pageSettings={pageSettings}
        utm={utm}
        prefill={prefill}
        onModalClose={onCancelPopupClick}
        open={isPopupOpen}
        /*
         * react-calendly uses React's Portal feature (https://reactjs.org/docs/portals.html) to render the popup modal. As a result, you'll need to
         * specify the rootElement property to ensure that the modal is inserted into the correct domNode.
         */
        rootElement={document.getElementById('root')}
      />
      {/* )} */}
    </>
  );
}

export default CtaCardSchedule;
